import { render, staticRenderFns } from "./dsjj.vue?vue&type=template&id=1e87dc41&scoped=true&"
import script from "./dsjj.vue?vue&type=script&lang=js&"
export * from "./dsjj.vue?vue&type=script&lang=js&"
import style0 from "./dsjj.vue?vue&type=style&index=0&id=1e87dc41&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87dc41",
  null
  
)

export default component.exports